import { useTranslation } from "react-i18next";

import {
	Box,
	Typography
} from "@launchmetrics/lm-ui";

import { FeedClipping } from "./fields/FeedClipping";
import { Language } from "./fields/common/Language";
import { Currency } from "./fields/common/Currency";
import { GroupLocation } from "./fields/common/GroupLocation";
import { useFeedWarnings } from "./hooks";
import { Period } from "./fields/Period";
import { useEffect } from "react";
import { setReportClipping } from "store/article/report/reducers";
import { useDispatch, useSelector } from "react-redux";
import { State } from "store/types";

export const PowerPoint: React.FC = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	let feedClippings = useSelector((state: State) => state.article.report.configuration.definition.settings.feedClippings);

	useEffect(() => {
		if (!feedClippings || !feedClippings.length) {
			dispatch(setReportClipping({ feedId: "all", count: 10 }));
		}
	}, [dispatch, feedClippings]);

	const warning = useFeedWarnings();

	return (
		<>
			{warning && 
				<Box className='side-panel-content-entry'>
					{warning}
				</Box>
			}
			<Box className='side-panel-content-entry'>
				<Period />
			</Box>
			<Box className='side-panel-content-entry'>
				<Typography variant={'textSmSemibold'}>{t('reports.groups')}</Typography>
				<GroupLocation />
			</Box>

			<Box className='side-panel-content-entry'>
				<Typography variant={'textSmSemibold'}>{t('reports.settings')}</Typography>
				<Language />
				<Currency />
			</Box>

			<Box className='side-panel-content-entry'>
				<FeedClipping />
			</Box>
		</>
	);
};
